import React, { useEffect, useState, createElement } from 'react';
import { CheckIcon, ClockIcon, LockIcon, ShieldCheckIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, BookOpenIcon, HeartHandshakeIcon, MessageCircleIcon, FileTextIcon, BrainCircuitIcon, UsersIcon, TrendingUpIcon, AlertCircleIcon } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingCard } from './components/PricingCard';
import { TestimonialCard } from './components/TestimonialCard';
import { BonusCard } from './components/BonusCard';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ImageCarousel } from './components/ImageCarousel';
import { FAQItem } from './components/FAQItem';
import { Footer } from './components/Footer';
export function App() {
  const [selectedPrice, setSelectedPrice] = useState('$28.990');
  const scrollToPricing = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e.preventDefault();
    const packSection = document.getElementById('elegi-tu-pack');
    if (packSection) {
      packSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  useEffect(() => {
    // Meta Pixel
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    w.fbq('init', '804808849254877');
    w.fbq('track', 'PageView');
  }, []);
  const trackAddToCart = () => {
    const w = window as any;
    if (w.fbq) w.fbq('track', 'AddToCart');
  };
  useEffect(() => {
    const eliteRadio = document.getElementById('pack-elite') as HTMLInputElement;
    const baseRadio = document.getElementById('pack-base') as HTMLInputElement;
    const updatePrice = () => {
      if (eliteRadio?.checked) {
        setSelectedPrice('$28.990');
      } else if (baseRadio?.checked) {
        setSelectedPrice('$19.990');
      }
    };
    eliteRadio?.addEventListener('change', updatePrice);
    baseRadio?.addEventListener('change', updatePrice);
    return () => {
      eliteRadio?.removeEventListener('change', updatePrice);
      baseRadio?.removeEventListener('change', updatePrice);
    };
  }, []);
  return <div className="min-h-screen bg-[#FAF9F6] font-sans text-gray-900" data-id="element-0">
      {/* STICKY ALERT BAR */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-[#C0392B] text-white py-1 px-4 shadow-lg" data-id="element-1">
        <div className="max-w-7xl mx-auto flex flex-row items-center justify-center gap-3 sm:gap-4" data-id="element-2">
          <div className="flex items-center gap-1.5 text-[10px] sm:text-xs font-bold" data-id="element-3">
            <span data-id="element-4">⏰</span>
            <span data-id="element-5">OFERTA POR TIEMPO LIMITADO</span>
          </div>
          <span className="text-white font-bold text-[10px] sm:text-xs" data-id="element-6">
            Cierra en:
          </span>
          <div className="bg-white rounded px-2 py-0.5 font-extrabold text-sm sm:text-base text-[#27AE60]" data-id="element-7">
            <CountdownTimer initialMinutes={15} data-id="element-8" />
          </div>
          <button onClick={scrollToPricing} className="flex-shrink-0 bg-[#27AE60] hover:bg-[#229954] text-white px-3 py-1 sm:px-4 sm:py-1 rounded-full text-[10px] sm:text-[11px] font-bold transition-all whitespace-nowrap shadow-md border border-white/30" data-id="element-9">
            ASEGURAR MI PRECIO
          </button>
        </div>
      </div>

      {/* HERO SECTION */}
      <section className="pt-16 pb-12 md:pt-20 md:pb-16 px-4 bg-[#2C3E50] text-white overflow-hidden relative" data-id="element-10">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-11"></div>
        <div className="max-w-5xl mx-auto text-center relative z-10 space-y-6" data-id="element-12">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight px-2" data-id="element-13">
            Recuperá la conexión con tu pareja y transformá tu relación en{' '}
            <span className="text-[#FFD700]" data-id="element-14">
              24 HS<span className="text-[#FFD700]" data-id="element-15">.</span>
            </span>
          </h1>
          <p className="text-xl md:text-2xl font-bold text-white -mt-2" data-id="element-16">
            SIN MESES DE TERAPIA
          </p>

          <div className="relative mx-auto w-full max-w-2xl my-8" data-id="element-17">
            <div className="absolute inset-0 bg-[#27AE60]/20 blur-3xl rounded-full" data-id="element-18"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cjETWVAjw5UE9AmyA8Hrve/MOCK_UP_PRINCIPAL.png" alt="Mockup del Método Reset 24h + 4 Bonos + Tablet" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-19" />
          </div>

          <p className="text-lg md:text-xl text-gray-200 leading-relaxed max-w-3xl mx-auto" data-id="element-20">
            <strong data-id="element-21">El Método Reset 24h:</strong> el plan paso a paso para
            frenar el conflicto, recuperar la calma y volver a sentirte en
            equipo con tu pareja, sin esperar meses para ver resultados.
          </p>

          <div className="flex flex-wrap justify-center gap-3 text-sm font-medium" data-id="element-22">
            <div className="bg-[#2C3E50] border-2 border-[#27AE60] px-4 py-2 rounded-lg flex items-center gap-2" data-id="element-23">
              <CheckIcon className="w-4 h-4 text-[#27AE60]" data-id="element-24" />
              📄 100% Digital (PDF)
            </div>
            <div className="bg-[#2C3E50] border-2 border-[#27AE60] px-4 py-2 rounded-lg flex items-center gap-2" data-id="element-25">
              <CheckIcon className="w-4 h-4 text-[#27AE60]" data-id="element-26" />⚡ Acceso
              inmediato
            </div>
            <div className="bg-[#2C3E50] border-2 border-[#27AE60] px-4 py-2 rounded-lg flex items-center gap-2" data-id="element-27">
              <CheckIcon className="w-4 h-4 text-[#27AE60]" data-id="element-28" />
              🛡️ Compra oficial verificada
            </div>
          </div>

          <div className="space-y-3" data-id="element-29">
            <button onClick={scrollToPricing} className="bg-[#27AE60] hover:bg-[#229954] text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center justify-center gap-2 animate-pulse" data-id="element-30">
              QUIERO RECUPERAR MI RELACIÓN AHORA
              <TrendingUpIcon className="w-5 h-5" data-id="element-31" />
            </button>
            <p className="text-sm text-gray-300 flex items-center justify-center gap-2" data-id="element-32">
              <LockIcon className="w-4 h-4" data-id="element-33" />
              Garantía 7 días · Pago 100% seguro · Mercado Pago
            </p>
          </div>
        </div>
      </section>

      {/* PAIN POINTS SECTION */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-34">
        <div className="max-w-4xl mx-auto" data-id="element-35">
          <div className="text-center mb-8" data-id="element-36">
            <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-3" data-id="element-37">
              😔 Si estás en pareja, esto te va a sonar familiar...
            </h2>
            <div className="w-20 h-1 bg-[#27AE60] mx-auto rounded-full" data-id="element-38"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-3" data-id="element-39">
            {['💔 Te sentís más como compañero de cuarto que como pareja.', '😤 Las discusiones se disparan por cualquier cosa y nunca se resuelven.', '🤐 El silencio en casa es más fuerte que cualquier grito.', '🗣️ Sentís que hablás y no te escuchan.', '💞 El amor todavía está ahí, pero la conexión parece rota.'].map((pain, idx) => <div key={idx} className="bg-white border-2 border-[#E74C3C] p-4 rounded-lg hover:shadow-md transition-shadow" data-id="element-40">
                <p className="text-base text-gray-700 font-medium" data-id="element-41">{pain}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* WHY PREVIOUS FAILED */}
      <section className="py-12 md:py-16 px-4 bg-[#FAF9F6] border-y border-gray-200" data-id="element-42">
        <div className="max-w-4xl mx-auto" data-id="element-43">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-4 text-center" data-id="element-44">
            ❌ No es tu culpa: nadie te dio una herramienta para desactivar la
            crisis en tiempo real.
          </h2>
          <p className="text-gray-600 mb-6 text-base text-center" data-id="element-45">
            Esto es lo que volvió a fallar una y otra vez:
          </p>
          <div className="grid md:grid-cols-3 gap-3 max-w-3xl mx-auto" data-id="element-46">
            <div className="bg-white border-2 border-[#E74C3C] px-3 py-2.5 rounded-lg" data-id="element-47">
              <div className="flex items-center gap-2 mb-1" data-id="element-48">
                <span className="text-lg" data-id="element-49">🧠</span>
                <strong className="text-gray-900 text-sm" data-id="element-50">
                  Cerebro Secuestrado
                </strong>
              </div>
              <p className="text-xs text-gray-700" data-id="element-51">
                Intentar hablar cuando la emoción domina la razón.
              </p>
            </div>
            <div className="bg-white border-2 border-[#E74C3C] px-3 py-2.5 rounded-lg" data-id="element-52">
              <div className="flex items-center gap-2 mb-1" data-id="element-53">
                <span className="text-lg" data-id="element-54">⏰</span>
                <strong className="text-gray-900 text-sm" data-id="element-55">
                  La Trampa del Tiempo
                </strong>
              </div>
              <p className="text-xs text-gray-700" data-id="element-56">
                Esperar que "pase solo" mientras el resentimiento se agrava.
              </p>
            </div>
            <div className="bg-white border-2 border-[#E74C3C] px-3 py-2.5 rounded-lg" data-id="element-57">
              <div className="flex items-center gap-2 mb-1" data-id="element-58">
                <span className="text-lg" data-id="element-59">💔</span>
                <strong className="text-gray-900 text-sm" data-id="element-60">
                  Falta de Logística
                </strong>
              </div>
              <p className="text-xs text-gray-700" data-id="element-61">
                Creer que el amor es suficiente sin herramientas de gestión.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PRODUCT PRESENTATION */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-62">
        <div className="max-w-4xl mx-auto text-center" data-id="element-63">
          <h2 className="text-2xl md:text-4xl font-extrabold text-[#2C3E50] mb-4" data-id="element-64">
            💚 Salva Tu Relación:{' '}
            <span className="text-[#27AE60]" data-id="element-65">El Método Reset 24h</span>
          </h2>
          <p className="text-xl text-gray-600 mb-12 leading-relaxed" data-id="element-66">
            El plan paso a paso para que en menos de 24 horas puedas detener el
            incendio emocional en tu relación, reescribir las reglas invisibles
            y reconstruir la conexión.
          </p>

          <div className="bg-[#FAF9F6] rounded-2xl p-8 text-left mb-12 border-2 border-[#27AE60] shadow-sm" data-id="element-67">
            <h3 className="text-xl font-bold text-[#2C3E50] mb-6 text-center" data-id="element-68">
              Beneficios concretos que vas a lograr:
            </h3>
            <div className="space-y-4 max-w-2xl mx-auto" data-id="element-69">
              <div className="flex items-start gap-4" data-id="element-70">
                <div className="bg-white p-1 rounded-full shadow-sm mt-1" data-id="element-71">
                  <CheckIcon className="w-6 h-6 text-[#27AE60]" data-id="element-72" />
                </div>
                <p className="text-lg text-gray-700" data-id="element-73">
                  Detener una discusión en <strong data-id="element-74">3 minutos</strong> sin que
                  escale.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-75">
                <div className="bg-white p-1 rounded-full shadow-sm mt-1" data-id="element-76">
                  <CheckIcon className="w-6 h-6 text-[#27AE60]" data-id="element-77" />
                </div>
                <p className="text-lg text-gray-700" data-id="element-78">
                  Poder hablar sin que el otro se ponga a la defensiva.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-79">
                <div className="bg-white p-1 rounded-full shadow-sm mt-1" data-id="element-80">
                  <CheckIcon className="w-6 h-6 text-[#27AE60]" data-id="element-81" />
                </div>
                <p className="text-lg text-gray-700" data-id="element-82">
                  Redefinir acuerdos claros sobre temas que hoy generan peleas
                  (dinero, hijos, intimidad, rutinas).
                </p>
              </div>
            </div>
          </div>

          <button onClick={scrollToPricing} className="bg-[#27AE60] hover:bg-[#229954] text-white px-10 py-5 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center gap-3 animate-pulse" data-id="element-83">
            QUIERO LA SOLUCIÓN AHORA
            <CheckIcon className="w-6 h-6" data-id="element-84" />
          </button>
        </div>
      </section>

      {/* PRODUCT PREVIEW */}
      <section className="py-12 md:py-16 px-4 bg-[#2C3E50] text-white overflow-hidden" data-id="element-85">
        <div className="max-w-6xl mx-auto text-center" data-id="element-86">
          <h2 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-87">
            📖 Mirá por dentro el Método Reset 24h:
          </h2>
          <ImageCarousel images={[{
          src: 'https://cdn.magicpatterns.com/uploads/7CrVGAU7fwVgDt98D7PTHu/imagen_1.png',
          alt: 'Los 3 Momentos más Difíciles que Superamos'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/tBK4vgU3ZtC3R5n9dE5uYe/imagen_3.png',
          alt: 'La Técnica STOP: Dejar de Reaccionar para Empezar a Sanar'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/wCUa65bVqKQNLasoK94ic1/imagen_5.png',
          alt: 'La Técnica del Yo Siento en la Intimidad'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/dsYK31i7VVcDXYxv72dXF2/imagen_6.png',
          alt: 'Ancla o Trampolín: ¿Cuál Eres?'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/tkZYDtST8TpHjb8tJK8evx/imagen_7.png',
          alt: 'Desenmascarando los Mitos del Amor'
        }]} data-id="element-88" />
        </div>
      </section>

      {/* QUÉ VAS A LOGRAR */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-89">
        <div className="max-w-4xl mx-auto text-center" data-id="element-90">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-8" data-id="element-91">
            🎯 ¿Qué vas a lograr con el Método Reset 24h?
          </h2>
          <div className="space-y-4 max-w-3xl mx-auto text-left" data-id="element-92">
            {['Vas a poder frenar cualquier discusión antes de que escale y lastime.', 'Vas a entender por qué se repiten siempre las mismas peleas y cómo cortarlas de raíz.', 'Vas a aprender a comunicarte sin que el otro se ponga a la defensiva.', 'Vas a redefinir los acuerdos invisibles que hoy generan el 80% de los conflictos.', 'Vas a recuperar la complicidad y la conexión que sentían al principio.', 'Vas a tener un plan claro para manejar los temas difíciles: dinero, hijos, intimidad, rutinas.', 'Vas a aplicar herramientas prácticas y concretas para transformar la dinámica de tu relación.'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-93">
                <div className="bg-[#27AE60]/10 p-1 rounded-full mt-1 flex-shrink-0" data-id="element-94">
                  <CheckIcon className="w-5 h-5 text-[#27AE60]" data-id="element-95" />
                </div>
                <p className="text-lg text-gray-700" data-id="element-96">{item}</p>
              </div>)}
          </div>
          <div className="mt-10" data-id="element-97">
            <button onClick={scrollToPricing} className="bg-[#27AE60] hover:bg-[#229954] text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 animate-pulse" data-id="element-98">
              QUIERO EL MÉTODO COMPLETO AHORA
            </button>
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-99">
        <div className="max-w-5xl mx-auto" data-id="element-100">
          <div className="text-center mb-10" data-id="element-101">
            <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-3" data-id="element-102">
              ✨ Esto es lo que vas a recibir hoy:
            </h2>
            <div className="w-20 h-1 bg-[#27AE60] mx-auto rounded-full" data-id="element-103"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-104">
            <div className="flex gap-4 items-start p-6 rounded-xl bg-[#FAF9F6] hover:bg-white transition-colors border border-transparent hover:border-[#27AE60]" data-id="element-105">
              <div className="bg-[#27AE60]/10 p-3 rounded-lg text-[#27AE60]" data-id="element-106">
                <ShieldCheckIcon className="w-8 h-8" data-id="element-107" />
              </div>
              <div data-id="element-108">
                <h3 className="text-xl font-bold text-[#2C3E50] mb-2" data-id="element-109">
                  Protocolo de Desescalada
                </h3>
                <p className="text-gray-600" data-id="element-110">
                  La técnica exacta para frenar cualquier discusión en 180
                  segundos.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start p-6 rounded-xl bg-[#FAF9F6] hover:bg-white transition-colors border border-transparent hover:border-[#27AE60]" data-id="element-111">
              <div className="bg-[#27AE60]/10 p-3 rounded-lg text-[#27AE60]" data-id="element-112">
                <TrendingUpIcon className="w-8 h-8" data-id="element-113" />
              </div>
              <div data-id="element-114">
                <h3 className="text-xl font-bold text-[#2C3E50] mb-2" data-id="element-115">
                  La Rueda de la Satisfacción
                </h3>
                <p className="text-gray-600" data-id="element-116">
                  Un mapa visual para identificar las áreas críticas de tu
                  relación y saber exactamente qué arreglar.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start p-6 rounded-xl bg-[#FAF9F6] hover:bg-white transition-colors border border-transparent hover:border-[#27AE60]" data-id="element-117">
              <div className="bg-[#27AE60]/10 p-3 rounded-lg text-[#27AE60]" data-id="element-118">
                <MessageCircleIcon className="w-8 h-8" data-id="element-119" />
              </div>
              <div data-id="element-120">
                <h3 className="text-xl font-bold text-[#2C3E50] mb-2" data-id="element-121">
                  Guía de Comunicación Asertiva
                </h3>
                <p className="text-gray-600" data-id="element-122">
                  Cómo pedir lo que necesitás sin que el otro se sienta atacado,
                  y empezar a lograr acuerdos reales.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start p-6 rounded-xl bg-[#FAF9F6] hover:bg-white transition-colors border border-transparent hover:border-[#27AE60]" data-id="element-123">
              <div className="bg-[#27AE60]/10 p-3 rounded-lg text-[#27AE60]" data-id="element-124">
                <HeartHandshakeIcon className="w-8 h-8" data-id="element-125" />
              </div>
              <div data-id="element-126">
                <h3 className="text-xl font-bold text-[#2C3E50] mb-2" data-id="element-127">
                  El Nuevo Contrato de Pareja
                </h3>
                <p className="text-gray-600" data-id="element-128">
                  Plantillas listas para definir reglas, límites y compromisos
                  concretos que los blinden ante futuros conflictos.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start p-6 rounded-xl bg-[#FAF9F6] hover:bg-white transition-colors border border-transparent hover:border-[#27AE60] md:col-span-2 md:w-1/2 md:mx-auto" data-id="element-129">
              <div className="bg-[#27AE60]/10 p-3 rounded-lg text-[#27AE60]" data-id="element-130">
                <BrainCircuitIcon className="w-8 h-8" data-id="element-131" />
              </div>
              <div data-id="element-132">
                <h3 className="text-xl font-bold text-[#2C3E50] mb-2" data-id="element-133">
                  Auditoría de Pensamientos
                </h3>
                <p className="text-gray-600" data-id="element-134">
                  Ejercicios prácticos para detectar las trampas mentales que te
                  hacen ver a tu pareja como un enemigo, y empezar a verla como
                  tu aliada.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-135">
            <button onClick={scrollToPricing} className="bg-[#27AE60] hover:bg-[#229954] text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all animate-pulse" data-id="element-136">
              QUIERO EL MÉTODO COMPLETO AHORA
            </button>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-12 md:py-16 px-4 bg-[#2C3E50] text-white relative overflow-hidden" data-id="element-137">
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#27AE60]/10 rounded-full blur-3xl" data-id="element-138"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#27AE60]/10 rounded-full blur-3xl" data-id="element-139"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-140">
          <div className="text-center mb-16" data-id="element-141">
            <span className="bg-[#27AE60] text-white font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider mb-4 inline-block" data-id="element-142">
              🎁 Oferta Especial
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-143">
              BONUS EXCLUSIVOS INCLUIDOS CON TU COMPRA
            </h2>
            <p className="text-xl text-gray-200" data-id="element-144">¡GRATIS POR EL DÍA DE HOY!</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-145">
            <BonusCard number="01" title="Reconexión Íntima" description="Despertá el deseo que se fue apagando con el tiempo. Ejercicios concretos para recuperar la intimidad física y emocional." value="$9.000 ARS" data-id="element-146" />
            <BonusCard number="02" title="Intimidad Radical" description="Recuperá la conexión sexual y emocional profunda con tu pareja." value="$9.000 ARS" data-id="element-147" />
            <BonusCard number="03" title="Reconstrucción Individual" description="Trabajá la ansiedad, el enojo y el miedo que te paralizan adentro de la relación." value="$9.000 ARS" data-id="element-148" />
            <BonusCard number="04" title="Conexión Profunda" description="La gratitud como herramienta real para transformar la dinámica diaria de tu pareja." value="$9.000 ARS" data-id="element-149" />
          </div>

          <div className="bg-[#27AE60]/20 border-2 border-[#27AE60] rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-150">
            <p className="text-lg text-gray-200 mb-2" data-id="element-151">
              VALOR TOTAL DE LOS 4 BONOS:
            </p>
            <div className="flex flex-col items-center justify-center gap-2 text-2xl md:text-3xl font-bold" data-id="element-152">
              <span className="line-through text-gray-400" data-id="element-153">$39.960 ARS</span>
              <span className="text-[#27AE60]" data-id="element-154">
                ✨ Hoy te los llevás por: $0 ✨
              </span>
              <span className="text-white text-lg" data-id="element-155">
                Incluidos GRATIS con tu compra
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="pricing" className="py-16 md:py-24 px-4 bg-gray-50 scroll-mt-20" data-id="element-156">
        <div className="max-w-5xl mx-auto" data-id="element-157">
          {/* COUNTDOWN BOX */}
          <div className="bg-[#2C3E50] rounded-2xl p-8 mb-8 text-center shadow-xl" data-id="element-158">
            <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-6 uppercase" data-id="element-159">
              El precio de lanzamiento termina en
            </h2>

            <div className="flex justify-center mb-6" data-id="element-160">
              <CountdownTimer initialMinutes={15} showLabels={true} data-id="element-161" />
            </div>

            <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-162">
              <span className="bg-white/10 border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full flex items-center gap-1.5" data-id="element-163">
                🔥 Últimas unidades disponibles
              </span>
              <span className="bg-white/10 border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full flex items-center gap-1.5" data-id="element-164">
                📢 Oferta de Lanzamiento
              </span>
              <span className="bg-white/10 border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full flex items-center gap-1.5" data-id="element-165">
                📈 Precio sube al terminar
              </span>
            </div>

            <div className="max-w-md mx-auto" data-id="element-166">
              <div className="w-full bg-gray-500 rounded-full h-4 overflow-hidden" data-id="element-167">
                <div className="h-4 rounded-full transition-all" style={{
                width: '80%',
                background: 'linear-gradient(to right, #E74C3C, #F39C12)'
              }} data-id="element-168"></div>
              </div>
              <p className="text-sm text-gray-300 font-bold mt-2 uppercase tracking-wider" data-id="element-169">
                80% de cupos ocupados
              </p>
            </div>
          </div>

          {/* TITLE BELOW COUNTDOWN */}
          <h2 id="elegi-tu-pack" className="text-2xl md:text-4xl font-extrabold text-[#2C3E50] mb-3 md:mb-8 text-center scroll-mt-16" data-id="element-170">
            ELEGÍ TU PACK
          </h2>

          <div className="grid md:grid-cols-2 gap-3 md:gap-6 max-w-4xl mx-auto items-stretch" data-id="element-171">
            {/* PACK ÉLITE - PRIMERO */}
            <button onClick={() => {
            const eliteRadio = document.getElementById('pack-elite') as HTMLInputElement;
            if (eliteRadio) {
              eliteRadio.checked = true;
              setSelectedPrice('$28.990');
            }
          }} className="bg-white border-4 border-[#27AE60] rounded-xl p-3 md:p-6 text-left hover:shadow-xl transition-all relative group shadow-[0_0_15px_rgba(39,174,96,0.3)]" data-id="element-172">
              <div className="absolute top-3 right-3" data-id="element-173">
                <input type="radio" id="pack-elite" name="pack" defaultChecked className="w-5 h-5 accent-[#27AE60]" data-id="element-174" />
              </div>
              <div className="bg-[#27AE60] text-white px-2 py-0.5 rounded-full text-[10px] font-bold inline-block mb-1" data-id="element-175">
                ⭐ MÁS ELEGIDO
              </div>
              <h3 className="text-lg md:text-2xl font-extrabold text-[#2C3E50] mb-1" data-id="element-176">
                PACK ÉLITE
              </h3>
              <div className="text-xs md:text-sm text-gray-700 space-y-1" data-id="element-177">
                <p className="font-semibold" data-id="element-178">
                  ✅ Método Reset 24h + 4 Bonos 🎁{' '}
                  <span className="text-[#27AE60] font-bold" data-id="element-179">GRATIS</span>
                </p>
                <p className="font-semibold" data-id="element-180">
                  ✅ Los 5 Errores que Destrozan las Parejas
                </p>
                <p className="text-[11px] pl-5 text-gray-500" data-id="element-181">
                  Descubrí los patrones ocultos que sabotean tu relación sin que
                  te des cuenta.
                </p>
              </div>
              <div className="mt-2 pt-2 border-t border-gray-200 flex items-baseline gap-2" data-id="element-182">
                <span className="text-2xl md:text-3xl font-extrabold text-[#27AE60]" data-id="element-183">
                  $28.990
                </span>
                <span className="text-sm text-gray-400 line-through" data-id="element-184">
                  $58.975
                </span>
                <span className="text-[10px] text-[#E74C3C] font-bold" data-id="element-185">
                  -51%
                </span>
              </div>
            </button>

            {/* PACK BASE - SEGUNDO */}
            <button onClick={() => {
            const baseRadio = document.getElementById('pack-base') as HTMLInputElement;
            if (baseRadio) {
              baseRadio.checked = true;
              setSelectedPrice('$19.990');
            }
          }} className="bg-white border-2 border-[#27AE60] rounded-xl p-3 md:p-6 text-left hover:shadow-xl transition-all relative group hover:border-[#27AE60]" data-id="element-186">
              <div className="absolute top-3 right-3" data-id="element-187">
                <input type="radio" id="pack-base" name="pack" className="w-5 h-5 accent-[#27AE60]" data-id="element-188" />
              </div>
              <h3 className="text-lg md:text-2xl font-extrabold text-[#2C3E50] mb-1" data-id="element-189">
                PACK BASE
              </h3>
              <div className="text-xs md:text-sm text-gray-700" data-id="element-190">
                <p className="font-semibold" data-id="element-191">
                  ✅ Método Reset 24h + 4 Bonos 🎁{' '}
                  <span className="text-[#27AE60] font-bold" data-id="element-192">GRATIS</span>
                </p>
              </div>
              <div className="mt-2 pt-2 border-t border-gray-200 flex items-baseline gap-2" data-id="element-193">
                <span className="text-2xl md:text-3xl font-extrabold text-[#27AE60]" data-id="element-194">
                  $19.990
                </span>
                <span className="text-sm text-gray-400 line-through" data-id="element-195">
                  $49.975
                </span>
                <span className="text-[10px] text-[#E74C3C] font-bold" data-id="element-196">
                  -60%
                </span>
              </div>
            </button>
          </div>

          {/* CHECKOUT BOX */}
          <div className="mt-4 md:mt-8 max-w-2xl mx-auto bg-[#FAF9F6] border-2 border-[#27AE60] rounded-xl p-3 md:p-6 text-center" data-id="element-197">
            <p className="text-sm md:text-lg font-extrabold text-gray-800 uppercase tracking-wide" data-id="element-198">
              ⏰ OFERTA VÁLIDA SOLO POR HOY
            </p>
            <p className="text-xs md:text-base font-bold text-gray-600 mb-2" data-id="element-199">
              {new Date().toLocaleDateString('es-AR', {
              weekday: 'long',
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            }).replace(/^\w/, (c: string) => c.toUpperCase())}
            </p>
            <div className="mb-2 md:mb-4" data-id="element-200">
              <p className="text-sm md:text-lg font-semibold text-gray-700 mb-1" data-id="element-201">
                Total a pagar:
              </p>
              <p className="text-3xl md:text-5xl font-extrabold text-[#27AE60]" data-id="element-202">
                {selectedPrice}
              </p>
            </div>
            <button onClick={() => {
            trackAddToCart();
            const eliteChecked = (document.getElementById('pack-elite') as HTMLInputElement)?.checked;
            if (eliteChecked) {
              window.open('https://checkout.nuvoraplus.online/cart/53422556217712:1', '_blank');
            } else {
              window.open('https://checkout.nuvoraplus.online/cart/53422554972528:1', '_blank');
            }
          }} className="w-full bg-[#27AE60] hover:bg-[#229954] text-white px-6 py-3 md:px-8 md:py-4 rounded-xl font-bold text-base md:text-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 animate-pulse" data-id="element-203">
              🔒 QUIERO ESTE PACK
            </button>
            <div className="mt-2 flex justify-center" data-id="element-204">
              <span className="text-xs border border-[#27AE60] bg-[#27AE60]/10 text-[#27AE60] font-bold px-3 py-1 rounded-lg" data-id="element-205">
                💳 Mercado Pago
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* HOW TO RECEIVE */}
      <section className="py-12 px-4 bg-white border-t border-gray-100" data-id="element-206">
        <div className="max-w-3xl mx-auto" data-id="element-207">
          <h2 className="text-xl md:text-2xl font-bold text-center text-[#2C3E50] mb-6" data-id="element-208">
            📦 CÓMO RECIBÍS EL MATERIAL
          </h2>
          <div className="grid md:grid-cols-3 gap-4" data-id="element-209">
            <div className="bg-[#FAF9F6] p-4 rounded-lg border-2 border-[#27AE60] text-center" data-id="element-210">
              <div className="w-10 h-10 bg-[#27AE60] text-white rounded-full flex items-center justify-center font-bold text-lg mx-auto mb-2" data-id="element-211">
                1
              </div>
              <p className="text-sm font-medium text-gray-800" data-id="element-212">
                💎 Elegís el pack
              </p>
            </div>

            <div className="bg-[#FAF9F6] p-4 rounded-lg border-2 border-[#27AE60] text-center" data-id="element-213">
              <div className="w-10 h-10 bg-[#27AE60] text-white rounded-full flex items-center justify-center font-bold text-lg mx-auto mb-2" data-id="element-214">
                2
              </div>
              <p className="text-sm font-medium text-gray-800" data-id="element-215">
                💰 Pagás con Mercado Pago
              </p>
            </div>

            <div className="bg-[#FAF9F6] p-4 rounded-lg border-2 border-[#27AE60] text-center" data-id="element-216">
              <div className="w-10 h-10 bg-[#27AE60] text-white rounded-full flex items-center justify-center font-bold text-lg mx-auto mb-2" data-id="element-217">
                3
              </div>
              <p className="text-sm font-medium text-gray-800" data-id="element-218">
                📧 Recibís el link al instante
              </p>
            </div>
          </div>
          <div className="bg-[#E74C3C]/10 border-2 border-[#E74C3C] rounded-lg p-3 mt-6" data-id="element-219">
            <p className="text-center text-sm text-gray-700 flex items-center justify-center gap-2" data-id="element-220">
              <AlertCircleIcon className="w-4 h-4 text-[#E74C3C]" data-id="element-221" />
              ⚠️ Si no lo ves, revisá Spam o Correo no deseado.
            </p>
          </div>
        </div>
      </section>

      {/* ABOUT AUTHOR */}
      <section className="py-12 md:py-16 px-4 bg-[#FAF9F6]" data-id="element-222">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12 border-4 border-[#27AE60] text-center" data-id="element-223">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-3" data-id="element-224">
            👩‍💼 QUIÉN SOY
          </h2>
          <div className="w-16 h-1 bg-[#27AE60] mb-6 mx-auto" data-id="element-225"></div>
          <div className="space-y-4 text-gray-700 leading-relaxed text-lg" data-id="element-226">
            <p data-id="element-227">
              Soy <strong data-id="element-228">Rosana Arguello</strong>, coach especialista en
              vínculos y relaciones de pareja.
            </p>
            <p data-id="element-229">
              Durante años acompañé a cientos de parejas en crisis y descubrí
              algo que nadie te dice: el problema casi nunca es falta de amor.
              El problema es la falta de herramientas concretas para manejar el
              conflicto en tiempo real.
            </p>
            <p data-id="element-230">
              Por eso creé el <strong data-id="element-231">Método Reset 24h</strong>: para darte en
              pocas horas lo que a muchas parejas les lleva meses aprender en
              terapia, sin el costo de las sesiones y sin esperar semanas para
              ver resultados.
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-232">
        <div className="max-w-6xl mx-auto" data-id="element-233">
          <div className="text-center mb-8" data-id="element-234">
            <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-3" data-id="element-235">
              ⭐ Lo que dicen quienes ya lo aplicaron
            </h2>
            <div className="w-20 h-1 bg-[#27AE60] mx-auto rounded-full" data-id="element-236"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-237">
            <TestimonialCard quote="Pensaba que nuestra relación no tenía solución. Llevábamos meses con las mismas peleas y cada vez nos alejábamos más. En menos de 24 horas de aplicar el método pudimos hablar sin que todo escalara. No lo puedo creer." name="Carolina M." location="Buenos Aires" data-id="element-238" />
            <TestimonialCard quote="Lo leí sola, sin que mi pareja lo leyera, y aun así cambió todo. Las herramientas son tan concretas que empecé a aplicarlas ese mismo día y noté la diferencia de inmediato." name="Valentina R." location="Córdoba" data-id="element-239" />
            <TestimonialCard quote="Llevábamos dos años con las mismas discusiones. Este método nos dio un lenguaje nuevo para hablar sin hervirnos la sangre. Vale cada peso." name="Marcela G." location="Rosario" data-id="element-240" />
            <TestimonialCard quote="Soy muy escéptica con estas cosas pero ya no sabía qué más hacer. Me sorprendió lo práctico y directo que es. Nada de filosofía, todo acción real." name="Sofía L." location="Mendoza" data-id="element-241" />
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-8 px-4 bg-[#2C3E50] text-white" data-id="element-242">
        <div className="max-w-xl mx-auto text-center" data-id="element-243">
          <ShieldCheckIcon className="w-12 h-12 text-[#27AE60] mx-auto mb-3" data-id="element-244" />
          <h2 className="text-xl md:text-2xl font-bold mb-2" data-id="element-245">
            🛡️ GARANTÍA DE SATISFACCIÓN TOTAL
          </h2>
          <h3 className="text-lg text-[#27AE60] font-semibold mb-2" data-id="element-246">
            Garantía de 7 días sin preguntas
          </h3>
          <p className="text-sm text-gray-200" data-id="element-247">
            Probalo. Si no sentís un cambio,{' '}
            <strong data-id="element-248">te devolvemos el dinero</strong>.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 md:py-16 px-4 bg-[#FAF9F6]" data-id="element-249">
        <div className="max-w-3xl mx-auto" data-id="element-250">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#2C3E50] mb-8" data-id="element-251">
            ❓ PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-3" data-id="element-252">
            <FAQItem emoji="👥" question="¿Funciona si mi pareja no participa?" answer="Sí, el cambio en tu reacción modifica la dinámica general. El método está diseñado para que puedas aplicar las herramientas vos solo/a y aun así generar cambios reales en la relación." data-id="element-253" />
            <FAQItem emoji="📚" question="¿Es un libro de autoayuda genérico?" answer="No. Es una guía práctica con protocolos, plantillas y ejercicios concretos basados en psicología aplicada a parejas en crisis." data-id="element-254" />
            <FAQItem emoji="📧" question="¿Cómo recibo el material?" answer="PDF descargable al instante en tu celular o tablet. Una vez que completás la compra, recibís un email con el link de descarga inmediata." data-id="element-255" />
            <FAQItem emoji="💰" question="¿Qué pasa si no me sirve?" answer="Tenés 7 días de garantía total. Si sentís que no te aportó nada, te devolvemos cada peso sin preguntas ni vueltas." data-id="element-256" />
            <FAQItem emoji="🎓" question="¿Necesito conocimientos de psicología?" answer="Para nada. Está escrito en un lenguaje simple, directo y sin tecnicismos para que cualquier persona pueda aplicarlo desde el primer momento." data-id="element-257" />
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-12 md:py-16 px-4 bg-white text-center border-t border-gray-200" data-id="element-258">
        <div className="max-w-3xl mx-auto" data-id="element-259">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-4" data-id="element-260">
            🌙 Esta noche podés seguir igual, esperando que algo cambie solo.
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-261">
            O podés hacer algo diferente. 💚
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-6" data-id="element-262">
            <div className="w-full sm:w-auto text-center" data-id="element-263">
              <p className="font-bold text-gray-700 mb-2" data-id="element-264">
                ○ PACK BASE — $19.990 ARS
              </p>
              <button onClick={() => {
              trackAddToCart();
              window.open('https://checkout.nuvoraplus.online/cart/53422554972528:1', '_blank');
            }} className="w-full sm:w-auto bg-[#27AE60] hover:bg-[#229954] text-white px-8 py-4 rounded-xl font-bold text-lg shadow-md transition-all animate-pulse" data-id="element-265">
                Quiero el Base
              </button>
            </div>

            <div className="w-full sm:w-auto text-center" data-id="element-266">
              <p className="font-bold text-[#27AE60] mb-2" data-id="element-267">
                ◉ PACK ÉLITE ⭐ — $28.990 ARS
              </p>
              <button onClick={() => {
              trackAddToCart();
              window.open('https://checkout.nuvoraplus.online/cart/53422556217712:1', '_blank');
            }} className="w-full sm:w-auto bg-[#27AE60] hover:bg-[#229954] text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg transition-all transform hover:scale-105 animate-pulse" data-id="element-268">
                Quiero el Élite
              </button>
            </div>
          </div>

          <p className="text-center text-sm text-gray-500 mt-8 flex items-center justify-center gap-1" data-id="element-269">
            <LockIcon className="w-4 h-4" data-id="element-270" /> Pago seguro · Mercado Pago
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <Footer data-id="element-271" />

      {/* SOCIAL PROOF POPUP */}
      <SocialProofPopup data-id="element-272" />
    </div>;
}